import { Component, OnInit, Input, AfterViewChecked } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';
import { UnidadeService } from './unidade.service';
import { CentroService } from './../centros/centro.service';
import { Unidade } from './unidade';
import { Centro } from './../centros/centro';


@Component({
  selector: 'app-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.css'],
  providers: [UnidadeService, CentroService]
})
export class FormUnidadeComponent implements OnInit {
  public busy: Promise<any>;
  unidade: Unidade;
  centros: Centro[];
  titulo: string = "Unidades";
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private location: Location,
    private unidadeService: UnidadeService,
    private centroService: CentroService
  ) {
    this.unidade = new Unidade();
  }

  getDocumento(): void {
    this.route.params.forEach((params: Params) => {
      let id = params['id'];

      if(id !== undefined ){
        this.busy = this.unidadeService.getUnidade(id)
          .then(unidade => this.unidade = unidade );
      }
    });
  }

  getCentros(): void{
    this.centroService.getCentros()
        .then((response) => this.centros = response);
  }

  salvar(): void {

    this.busy = this.unidadeService.saveUnidade(this.unidade)
            .then(() => this.goBack());

  }

  goBack(): void {
     this.router.navigate(['/unidades']);
  }

  ngOnInit() {
    this.getDocumento();
    this.getCentros();
  }

}



// WEBPACK FOOTER //
// ./src/app/unidades/form.component.ts